<template>
  <v-chip small outline :color="getColor()">
    <v-icon small left style="margin-right: 5px;">
      {{ getIcon() }}
    </v-icon>

    {{ $vuetify.t(getText()) }}
  </v-chip>
</template>

<script>
  import get from 'lodash/get';


  export default {
    props: {
      status: {
        type: String,
        default: ''
      }
    },

    data() {
      return {
        statusMap: {
          NEW: {
            color: 'info',
            icon: 'new_releases',
            i18n: '$vuetify.order.status.new'
          },
          ACCEPTED: {
            color: 'orange',
            icon: 'hourglass_empty',
            i18n: '$vuetify.order.status.inProgress'
          },
          READY: {
            color: 'success',
            icon: 'check',
            i18n: '$vuetify.order.status.ready'
          },
          CANCELLED: {
            color: 'red',
            icon: 'close',
            i18n: '$vuetify.order.status.cancelled'
          },
          REFUNDED: {
            color: 'grey',
            icon: 'replay',
            i18n: '$vuetify.order.status.refunded'
          },
          COMPLETED: {
            color: 'success',
            icon: 'check',
            i18n: '$vuetify.order.status.completed'
          },

          cvcFailed: {
            color: 'red',
            icon: 'close',
            i18n: '$vuetify.account.payment.status.cvcFailed'
          },
          postalCodeFailed: {
            color: 'red',
            icon: 'close',
            i18n: '$vuetify.account.payment.status.postalCodeFailed'
          },
          expiredCard: {
            color: 'red',
            icon: 'close',
            i18n: '$vuetify.account.payment.status.expiredCard'
          }
        }
      }
    },
    methods: {
      getText() {
        return get(this.statusMap, `[${this.status}].i18n`, '$vuetify.order.status.completed')
      },

      getIcon() {
        return get(this.statusMap, `[${this.status}].icon`, 'check')
      },

      getColor() {
        return get(this.statusMap, `[${this.status}].color`, 'success')
      }
    }
  }
</script>
